import React from "react";
export const BackButton: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M12.5 15L7.5 10L12.5 5" stroke="#F0F0F0" stroke-width="0.666667" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);

export const SatImage: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
    <path
      d="M12.8303 4.16999L9.97638 1.31608C9.87501 1.21471 9.70996 1.21424 9.61485 1.3215C8.82774 2.20911 8.47406 3.34668 8.55329 4.46064M12.8303 4.16999L15.6842 7.02389C15.7856 7.12526 15.786 7.29023 15.6797 7.38647C14.7678 8.21256 13.7039 8.57377 12.5396 8.44698M12.8303 4.16999L14.3869 2.61342M8.55329 4.46064C8.62414 5.45665 9.04109 6.43379 9.80378 7.19649C10.5253 7.91804 11.5998 8.34463 12.5396 8.44698M8.55329 4.46064L6.82584 6.18809M12.5396 8.44698L10.8122 10.1744M6.82584 6.18809L4.38915 3.75139C4.28777 3.65002 4.12342 3.65002 4.02205 3.75139L1.09911 6.67433C0.997734 6.7757 0.997734 6.94006 1.09911 7.04143L3.5358 9.47813M6.82584 6.18809L3.5358 9.47813M3.5358 9.47813L2.84418 10.1698C2.16837 10.8456 2.16837 11.9413 2.84418 12.6171L4.3832 14.1561C5.05901 14.8319 6.15471 14.8319 6.83052 14.1561L7.52214 13.4645M10.8122 10.1744L7.52214 13.4645M10.8122 10.1744L13.2489 12.6111C13.3503 12.7125 13.3503 12.8769 13.2489 12.9782L10.3259 15.9012C10.2246 16.0025 10.0602 16.0025 9.95884 15.9012L7.52214 13.4645"
      stroke="#F0F0F0"
      stroke-linecap="round"
    />
  </svg>
);

export const AddItemIconPlus: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M8 4V12M12 8H4" stroke="#B2B2B2" stroke-width="0.888889" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);

export const MsImagerIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="none">
    <path
      d="M14.9224 9.76609L13.5967 1.76669C13.4824 1.07647 12.8854 0.570312 12.1858 0.570312H11.6073H6.16926H4.52986H3.81314C3.11351 0.570312 2.51657 1.07647 2.40219 1.76669L1.91508 4.70605L1.67432 6.15889L1.07654 9.76609C0.93214 10.6374 1.60425 11.4301 2.48749 11.4301H4.51905H13.5114C14.3947 11.4301 15.0668 10.6374 14.9224 9.76609Z"
      stroke="#F0F0F0"
      stroke-width="0.6"
      stroke-linecap="round"
    />
    <path
      d="M4.52937 0.570312C6.1291 1.96059 9.89696 4.7144 8.37826 7.02388C7.01988 9.08957 5.16328 8.10429 3.99718 5.85388C3.33145 4.56912 1.91459 4.70605 1.91459 4.70605M6.16876 0.570312C7.03853 1.23759 9.45178 3.56686 9.82909 4.68363C10.3413 6.19982 9.89478 7.5789 8.853 8.63531C6.40663 11.116 3.94441 8.82093 3.28062 7.02388C2.79431 5.70735 1.67383 6.15889 1.67383 6.15889M11.6068 0.570312C10.3329 1.03876 10.1088 2.35238 11.057 3.28526C12.1118 4.32296 12.3024 5.2261 12.1484 6.439C11.9492 8.00819 10.7152 9.29967 9.56344 10.1525C7.83791 11.4301 4.51855 11.4301 4.51855 11.4301"
      stroke="#F0F0F0"
      stroke-width="0.6"
      stroke-linecap="round"
    />
  </svg>
);

export const AntennaIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M3.26641 12.7323C0.666406 10.1323 0.666406 5.86563 3.26641 3.26562" stroke="#F0F0F0" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M5.20078 10.7995C3.66745 9.26615 3.66745 6.73281 5.20078 5.13281" stroke="#F0F0F0" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M7.99935 9.33073C8.73573 9.33073 9.33268 8.73378 9.33268 7.9974C9.33268 7.26102 8.73573 6.66406 7.99935 6.66406C7.26297 6.66406 6.66602 7.26102 6.66602 7.9974C6.66602 8.73378 7.26297 9.33073 7.99935 9.33073Z"
      stroke="#F0F0F0"
      stroke-width="0.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M10.8008 5.20312C12.3341 6.73646 12.3341 9.26979 10.8008 10.8698" stroke="#F0F0F0" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M12.7344 3.26562C15.3344 5.86562 15.3344 10.0656 12.7344 12.6656" stroke="#F0F0F0" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);

export const SensorsIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 8" fill="none">
    <path
      d="M3.40039 3.99844C3.40039 5.98666 5.01217 7.59844 7.00039 7.59844C8.96117 7.59844 10.6004 5.95897 10.6004 3.99844C10.6004 2.01021 8.98862 0.398438 7.00039 0.398438C5.03965 0.398438 3.40039 2.03765 3.40039 3.99844Z"
      stroke="#F0F0F0"
      stroke-width="0.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.75576 1.11719C1.27534 1.97635 1 2.95979 1 3.99725C1 5.0409 1.26647 6.02232 1.73507 6.87719M12.2649 1.11719C12.7335 1.97208 13 2.95354 13 3.99725C13 5.03459 12.7246 6.01801 12.2442 6.87719"
      stroke="#F0F0F0"
      stroke-width="0.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const GPSIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M1.33398 8H3.33398" stroke="#F0F0F0" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M12.666 8H14.666" stroke="#F0F0F0" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M8 1.33594V3.33594" stroke="#F0F0F0" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M8 12.6641V14.6641" stroke="#F0F0F0" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M8.00065 12.6693C10.578 12.6693 12.6673 10.5799 12.6673 8.0026C12.6673 5.42528 10.578 3.33594 8.00065 3.33594C5.42332 3.33594 3.33398 5.42528 3.33398 8.0026C3.33398 10.5799 5.42332 12.6693 8.00065 12.6693Z"
      stroke="#F0F0F0"
      stroke-width="0.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
      stroke="#F0F0F0"
      stroke-width="0.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const ADCSIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none">
    <path
      d="M11.1809 4.34225L9.23315 2.3945C9.14525 2.3066 9.00198 2.30611 8.92092 2.40034C8.39571 3.01093 8.16025 3.78529 8.21421 4.54385M11.1809 4.34225L13.1286 6.29C13.2165 6.37789 13.217 6.52113 13.1238 6.60338C12.4987 7.15508 11.7726 7.39533 10.9793 7.30894M11.1809 4.34225L12.2606 3.26255M8.21421 4.54385C8.26335 5.23473 8.55256 5.91251 9.0816 6.44155C9.5821 6.94205 10.3274 7.23795 10.9793 7.30894M8.21421 4.54385L7.01598 5.74208M10.9793 7.30894L9.78106 8.50717M7.01598 5.74208L5.35762 4.08372C5.26972 3.99583 5.12722 3.99583 5.03933 4.08372L3.07552 6.04753C2.98762 6.13542 2.98762 6.27793 3.07552 6.36582L4.73388 8.02418M7.01598 5.74208L4.73388 8.02418M4.73388 8.02418L4.46633 8.29173C3.88037 8.87769 3.88037 9.82771 4.46633 10.4137L5.10947 11.0568C5.69543 11.6428 6.64546 11.6428 7.23142 11.0568L7.49896 10.7893M9.78106 8.50717L7.49896 10.7893M9.78106 8.50717L11.4394 10.1655C11.5273 10.2534 11.5273 10.3959 11.4394 10.4838L9.47561 12.4476C9.38772 12.5355 9.24522 12.5355 9.15732 12.4476L7.49896 10.7893"
      stroke="#F0F0F0"
      stroke-width="0.6"
      stroke-linecap="round"
    />
    <path
      d="M1.74219 4.33594L0.408854 5.66927L1.74219 7.0026L0.408854 8.33594L1.74219 9.66927"
      stroke="#F0F0F0"
      stroke-width="0.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M14.2585 4.33594L15.5918 5.66927L14.2585 7.0026L15.5918 8.33594L14.2585 9.66927" stroke="#F0F0F0" stroke-width="0.6" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);

export const ThrusterIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
    <path
      d="M8.7911 11.0128C8.14823 11.6641 8.57711 12.5394 8.9135 13.2211C9.40356 14.2136 9.0159 15.0987 7.99922 16C7.55436 13.7464 4.79922 12.7222 4.79922 10.4421C4.79922 8.69404 6.23857 7.2 7.99922 7.2C9.75987 7.2 11.1992 8.69404 11.1992 10.4421C11.1992 10.9761 11.0013 11.5046 10.7421 11.8316C10.7421 10.8327 9.50221 10.2924 8.7911 11.0128Z"
      stroke="#F0F0F0"
      stroke-width="0.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.13605 7.05967L3.64793 4.41388C4.3601 3.16758 5.68547 2.39844 7.1209 2.39844H8.87832C10.3137 2.39844 11.6391 3.16758 12.3513 4.41388L13.8632 7.05967C14.0746 7.42972 13.7558 7.87773 13.3369 7.79918L12.4225 7.62774C9.49939 7.07965 6.49983 7.07965 3.57668 7.62774L2.66231 7.79918C2.2434 7.87773 1.92459 7.42972 2.13605 7.05967Z"
      stroke="#F0F0F0"
      stroke-width="0.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const ScaleIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
    <path d="M1.83398 3.64844V16.6984H14.884" stroke="#F0F0F0" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M1.83398 16.6984L8.58398 10.3984" stroke="#F0F0F0" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);

export const WeightIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
    <path
      d="M9.18359 6.5C10.4262 6.5 11.4336 5.49264 11.4336 4.25C11.4336 3.00736 10.4262 2 9.18359 2C7.94095 2 6.93359 3.00736 6.93359 4.25C6.93359 5.49264 7.94095 6.5 9.18359 6.5Z"
      stroke="#F0F0F0"
      stroke-width="0.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.05863 6.5C4.73407 6.50337 4.41936 6.61192 4.16175 6.80936C3.90413 7.0068 3.7175 7.28247 3.62988 7.595L1.75863 14.375C1.70193 14.5944 1.6957 14.8239 1.7404 15.0461C1.78509 15.2683 1.87956 15.4774 2.01669 15.6579C2.15383 15.8383 2.33008 15.9853 2.53219 16.0879C2.7343 16.1905 2.95703 16.2459 3.18363 16.25H15.1836C15.4151 16.2499 15.6435 16.1962 15.8508 16.0932C16.0581 15.9902 16.2387 15.8405 16.3786 15.656C16.5184 15.4715 16.6136 15.2571 16.6568 15.0297C16.7 14.8023 16.6899 14.5679 16.6274 14.345L14.7336 7.625C14.651 7.30506 14.4651 7.02134 14.2047 6.81791C13.9443 6.61448 13.6241 6.50273 13.2936 6.5H5.05863Z"
      stroke="#F0F0F0"
      stroke-width="0.75"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const RenewableEnergyIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
    <g clip-path="url(#clip0_5906_24554)">
      <path d="M7.68359 2.75V3.5" stroke="#F0F0F0" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M2.43359 4.25L3.18359 5" stroke="#F0F0F0" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M0.933594 9.5H1.68359" stroke="#F0F0F0" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M11.0481 6.51948C10.4423 5.83745 9.64356 5.35562 8.7577 5.13788C7.87185 4.92014 6.94074 4.97677 6.08781 5.30026C5.23487 5.62376 4.50039 6.19883 3.98173 6.94926C3.46307 7.69968 3.18473 8.59001 3.1836 9.50223C3.1831 10.0027 3.26781 10.4995 3.4341 10.9715"
        stroke="#F0F0F0"
        stroke-width="0.75"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.07558 9.69275C6.10807 9.63432 6.15559 9.58565 6.21321 9.55176C6.27084 9.51787 6.33648 9.5 6.40333 9.5H14.2123C14.2792 9.5 14.3448 9.51787 14.4024 9.55176C14.4601 9.58565 14.5076 9.63432 14.5401 9.69275L17.8731 15.6927C17.9048 15.7498 17.9211 15.8142 17.9203 15.8795C17.9195 15.9448 17.9017 16.0088 17.8686 16.0651C17.8355 16.1214 17.7882 16.1681 17.7315 16.2005C17.6748 16.2329 17.6106 16.25 17.5453 16.25H3.07033C3.00501 16.25 2.94083 16.2329 2.88413 16.2005C2.82743 16.1681 2.78019 16.1214 2.74708 16.0651C2.71396 16.0088 2.69613 15.9448 2.69534 15.8795C2.69455 15.8142 2.71083 15.7498 2.74258 15.6927L6.07558 9.69275Z"
        stroke="#F0F0F0"
        stroke-width="0.75"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M8.80859 9.5L7.30859 16.25" stroke="#F0F0F0" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M11.8086 9.5L13.3086 16.25" stroke="#F0F0F0" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M4.93359 11.75H15.6833" stroke="#F0F0F0" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M3.68359 14H16.9338" stroke="#F0F0F0" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_5906_24554">
        <rect width="18" height="18" fill="white" transform="translate(0.5 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export const CopyIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <g clip-path="url(#clip0_5906_19033)">
      <path
        d="M10 4H5C4.44772 4 4 4.44772 4 5V10C4 10.5523 4.44772 11 5 11H10C10.5523 11 11 10.5523 11 10V5C11 4.44772 10.5523 4 10 4Z"
        stroke="#F0F0F0"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M2 8C1.45 8 1 7.55 1 7V2C1 1.45 1.45 1 2 1H7C7.55 1 8 1.45 8 2" stroke="#F0F0F0" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_5906_19033">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const ReportIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 18 18" fill="none">
    <path
      d="M2.23077 17L15.7692 17C16.449 17 17 16.449 17 15.7692L17 2.23077C17 1.55103 16.449 1 15.7692 1L2.23077 1C1.55103 1 1 1.55103 1 2.23077L1 15.7692C1 16.449 1.55103 17 2.23077 17Z"
      stroke="#ccf54e"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.07812 4.07812H6.53966M4.07812 7.15505H9.61659M14.5397 7.15505L10.8474 13.3089L6.53966 10.8474L4.07812 14.5397"
      stroke="#ccf54e"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const ReplaceIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <g clip-path="url(#clip0_5906_19037)">
      <path
        d="M10 1H8C7.44772 1 7 1.44772 7 2V4C7 4.55228 7.44772 5 8 5H10C10.5523 5 11 4.55228 11 4V2C11 1.44772 10.5523 1 10 1Z"
        stroke="#F0F0F0"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M1.5 3.5L3 5L4.5 3.5" stroke="#F0F0F0" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M3 5V2.5C3 2.10218 3.15804 1.72064 3.43934 1.43934C3.72064 1.15804 4.10218 1 4.5 1H5"
        stroke="#F0F0F0"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4 7H2C1.44772 7 1 7.44772 1 8V10C1 10.5523 1.44772 11 2 11H4C4.55228 11 5 10.5523 5 10V8C5 7.44772 4.55228 7 4 7Z"
        stroke="#F0F0F0"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5906_19037">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const EditIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path
      d="M6 1.5H2.5C2.23478 1.5 1.98043 1.60536 1.79289 1.79289C1.60536 1.98043 1.5 2.23478 1.5 2.5V9.5C1.5 9.76522 1.60536 10.0196 1.79289 10.2071C1.98043 10.3946 2.23478 10.5 2.5 10.5H9.5C9.76522 10.5 10.0196 10.3946 10.2071 10.2071C10.3946 10.0196 10.5 9.76522 10.5 9.5V6"
      stroke="#F0F0F0"
      stroke-width="0.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.18755 1.31066C9.38646 1.11175 9.65624 1 9.93755 1C10.2189 1 10.4886 1.11175 10.6875 1.31066C10.8865 1.50957 10.9982 1.77936 10.9982 2.06066C10.9982 2.34196 10.8865 2.61175 10.6875 2.81066L6.18105 7.31766C6.06232 7.43628 5.91565 7.52312 5.75455 7.57016L4.31805 7.99016C4.27502 8.00271 4.22942 8.00346 4.186 7.99234C4.14259 7.98122 4.10296 7.95863 4.07127 7.92694C4.03958 7.89525 4.01699 7.85562 4.00587 7.8122C3.99475 7.76879 3.9955 7.72318 4.00805 7.68016L4.42805 6.24366C4.47531 6.08269 4.56231 5.93619 4.68105 5.81766L9.18755 1.31066Z"
      stroke="#F0F0F0"
      stroke-width="0.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const TrashIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path d="M1.5 3H10.5" stroke="#F0F0F0" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M9.5 3V10C9.5 10.5 9 11 8.5 11H3.5C3 11 2.5 10.5 2.5 10V3" stroke="#F0F0F0" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M4 3V2C4 1.5 4.5 1 5 1H7C7.5 1 8 1.5 8 2V3" stroke="#F0F0F0" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);

export const ToggleButtonInactiveIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16" fill="none">
    <rect opacity="0.12" x="1" y="1" width="22" height="14" rx="2" fill="#F0F0F0" />
    <rect opacity="0.4" x="3" y="3" width="10" height="10" rx="1" fill="#F0F0F0" />
  </svg>
);

export const ToggleButtonActiveIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16" fill="none">
    <rect opacity="0.12" x="1" y="1" width="22" height="14" rx="2" fill="#F0F0F0" />
    <rect opacity="0.8" x="11" y="3" width="10" height="10" rx="1" fill="#CCF54E" />
  </svg>
);

export const ShowReportIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M3 5L9 10L3 15V5Z" stroke="#CCF54E" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M8.5765 4.68741C9.39138 4.46906 10.2456 4.4411 11.073 4.60568C11.9004 4.77027 12.6789 5.12299 13.3482 5.63656C14.0175 6.15013 14.5597 6.81078 14.9328 7.56741C15.3059 8.32404 15.5 9.15637 15.5 10C15.5 10.8436 15.3059 11.676 14.9328 12.4326C14.5597 13.1892 14.0175 13.8499 13.3482 14.3634C12.6789 14.877 11.9004 15.2297 11.073 15.3943C10.2456 15.5589 9.39138 15.5309 8.5765 15.3126"
      stroke="#CCF54E"
      stroke-linecap="round"
    />
  </svg>
);

export const CancelCrossIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M3 4H3.91873C4.22559 4 4.51546 4.14089 4.70504 4.38217L8.63361 9.38211C8.91852 9.74472 8.91853 10.2551 8.63362 10.6178L4.70504 15.6178C4.51546 15.8591 4.22559 16 3.91872 16H3M16 4H15.0813C14.7744 4 14.4845 4.14089 14.295 4.38217L10.3664 9.38211C10.0815 9.74472 10.0815 10.2551 10.3664 10.6178L14.295 15.6178C14.4845 15.8591 14.7744 16 15.0813 16H16"
      stroke="#FF3333"
      stroke-linejoin="round"
    />
  </svg>
);

export const SmallSatelliteIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
    <g opacity="0.6">
      <path
        d="M12.8303 4.16999L9.97638 1.31608C9.87501 1.21471 9.70996 1.21424 9.61485 1.3215C8.82774 2.20911 8.47406 3.34668 8.55329 4.46064M12.8303 4.16999L15.6842 7.02389C15.7856 7.12526 15.786 7.29023 15.6797 7.38647C14.7678 8.21256 13.7039 8.57377 12.5396 8.44698M12.8303 4.16999L14.3869 2.61342M8.55329 4.46064C8.62414 5.45665 9.04109 6.43379 9.80378 7.19649C10.5253 7.91804 11.5998 8.34463 12.5396 8.44698M8.55329 4.46064L6.82584 6.18809M12.5396 8.44698L10.8122 10.1744M6.82584 6.18809L4.38915 3.75139C4.28777 3.65002 4.12342 3.65002 4.02205 3.75139L1.09911 6.67433C0.997734 6.7757 0.997734 6.94006 1.09911 7.04143L3.5358 9.47813M6.82584 6.18809L3.5358 9.47813M3.5358 9.47813L2.84418 10.1698C2.16837 10.8456 2.16837 11.9413 2.84418 12.6171L4.3832 14.1561C5.05901 14.8319 6.15471 14.8319 6.83052 14.1561L7.52214 13.4645M10.8122 10.1744L7.52214 13.4645M10.8122 10.1744L13.2489 12.6111C13.3503 12.7125 13.3503 12.8769 13.2489 12.9782L10.3259 15.9012C10.2246 16.0025 10.0602 16.0025 9.95884 15.9012L7.52214 13.4645"
        stroke="#F0F0F0"
        stroke-linecap="round"
      />
    </g>
  </svg>
);

export const MagnetIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g opacity="0.6">
      <path
        d="M11.6519 4.94531H16.366L16.3778 12.912C16.2863 14.5693 15.5636 16.1286 14.358 17.2695C13.1525 18.4104 11.5557 19.0462 9.89594 19.0462C8.23614 19.0462 6.63939 18.4104 5.43384 17.2695C4.2283 16.1286 3.50555 14.5693 3.41413 12.912L3.40234 4.94531H8.11639L8.09871 12.4583C8.1557 12.8868 8.36636 13.28 8.69153 13.5648C9.0167 13.8496 9.43423 14.0065 9.86648 14.0065C10.2987 14.0065 10.7163 13.8496 11.0414 13.5648C11.3666 13.28 11.5773 12.8868 11.6342 12.4583L11.6519 4.94531Z"
        stroke="#F0F0F0"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M16.3664 8.48438H11.6523" stroke="#F0F0F0" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M8.11639 8.48438H3.40234" stroke="#F0F0F0" stroke-linecap="round" stroke-linejoin="round" />
    </g>
  </svg>
);

export const Rotate3dIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g opacity="0.6">
      <path
        d="M13.7223 6.2474C13.0365 3.52823 11.6273 1.66406 10.0007 1.66406C7.69982 1.66406 5.83398 5.3949 5.83398 9.9974C5.83398 14.5999 7.69982 18.3307 10.0007 18.3307C10.2857 18.3307 10.5648 18.2732 10.834 18.1641"
        stroke="#F0F0F0"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M12.6621 11.4219L15.8404 12.9719L14.2904 16.1502" stroke="#F0F0F0" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M15.8327 12.9776C14.3293 13.7151 12.271 14.1693 9.99935 14.1693C5.39685 14.1693 1.66602 12.3034 1.66602 10.0026C1.66602 7.70177 5.39685 5.83594 9.99935 5.83594C14.031 5.83594 17.3935 7.2676 18.166 9.16927"
        stroke="#F0F0F0"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
);

export const PaletteIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g opacity="0.6">
      <path
        d="M11.2507 5.83333C11.4808 5.83333 11.6673 5.64679 11.6673 5.41667C11.6673 5.18655 11.4808 5 11.2507 5C11.0205 5 10.834 5.18655 10.834 5.41667C10.834 5.64679 11.0205 5.83333 11.2507 5.83333Z"
        fill="#F0F0F0"
        stroke="#F0F0F0"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.5827 9.16927C14.8128 9.16927 14.9993 8.98272 14.9993 8.7526C14.9993 8.52249 14.8128 8.33594 14.5827 8.33594C14.3526 8.33594 14.166 8.52249 14.166 8.7526C14.166 8.98272 14.3526 9.16927 14.5827 9.16927Z"
        fill="#F0F0F0"
        stroke="#F0F0F0"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.08268 6.66927C7.3128 6.66927 7.49935 6.48272 7.49935 6.2526C7.49935 6.02249 7.3128 5.83594 7.08268 5.83594C6.85256 5.83594 6.66602 6.02249 6.66602 6.2526C6.66602 6.48272 6.85256 6.66927 7.08268 6.66927Z"
        fill="#F0F0F0"
        stroke="#F0F0F0"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.41667 10.8333C5.64679 10.8333 5.83333 10.6468 5.83333 10.4167C5.83333 10.1865 5.64679 10 5.41667 10C5.18655 10 5 10.1865 5 10.4167C5 10.6468 5.18655 10.8333 5.41667 10.8333Z"
        fill="#F0F0F0"
        stroke="#F0F0F0"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.99935 1.66406C5.41602 1.66406 1.66602 5.41406 1.66602 9.9974C1.66602 14.5807 5.41602 18.3307 9.99935 18.3307C10.771 18.3307 11.3727 17.7091 11.3727 16.9241C11.3727 16.5599 11.2227 16.2282 11.0085 15.9866C10.7668 15.7457 10.6435 15.4432 10.6435 15.0491C10.6404 14.8657 10.6742 14.6835 10.7429 14.5134C10.8116 14.3433 10.9139 14.1889 11.0436 14.0591C11.1733 13.9294 11.3278 13.8272 11.4979 13.7584C11.6679 13.6897 11.8501 13.6559 12.0335 13.6591H13.6968C16.2393 13.6591 18.326 11.5732 18.326 9.03073C18.3035 5.0074 14.5502 1.66406 9.99935 1.66406Z"
        stroke="#F0F0F0"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
);

export const MinimizeIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M3 13.0001L3 12.6762C3 12.2344 3.35817 11.8762 3.79999 11.8762L8.04979 11.8762L12.2 11.8762C12.6418 11.8762 13 12.2344 13 12.6762L13 13.0001"
      stroke="#F0F0F0"
      stroke-width="0.8"
      stroke-linejoin="round"
    />
  </svg>
);

export const MaximizeIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.9946 18L11.9941 6M6 12.0005L18 12" stroke="#F0F0F0" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);

export const CloseModalIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M2.40039 3.20312H3.13537C3.38086 3.20312 3.61276 3.31583 3.76443 3.50886L6.90728 7.50881C7.13521 7.7989 7.13521 8.20724 6.90729 8.49733L3.76443 12.4974C3.61276 12.6904 3.38086 12.8031 3.13537 12.8031H2.40039M12.8004 3.20312H12.0654C11.8199 3.20312 11.588 3.31583 11.4364 3.50886L8.2935 7.50881C8.06557 7.7989 8.06557 8.20724 8.2935 8.49733L11.4364 12.4974C11.588 12.6904 11.8199 12.8031 12.0654 12.8031H12.8004"
      stroke="#F0F0F0"
      stroke-width="0.8"
      stroke-linejoin="round"
    />
  </svg>
);

export const PlusIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path d="M2.50391 6H9.50391" stroke="#F0F0F0" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M6 2.5V9.5" stroke="#F0F0F0" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);

export const WhiteCrossIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M2.40039 3.20312H3.13537C3.38086 3.20312 3.61276 3.31583 3.76443 3.50886L6.90728 7.50881C7.13521 7.7989 7.13521 8.20724 6.90729 8.49733L3.76443 12.4974C3.61276 12.6904 3.38086 12.8031 3.13537 12.8031H2.40039M12.8004 3.20312H12.0654C11.8199 3.20312 11.588 3.31583 11.4364 3.50886L8.2935 7.50881C8.06557 7.7989 8.06557 8.20724 8.2935 8.49733L11.4364 12.4974C11.588 12.6904 11.8199 12.8031 12.0654 12.8031H12.8004"
      stroke="#F0F0F0"
      stroke-width="0.8"
      stroke-linejoin="round"
    />
  </svg>
);

export const MiniDropdownIconOpened: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g filter="url(#filter0_b_6668_9081)">
      <rect width="16" height="15.3333" transform="translate(0 0.335938)" fill="#090909" fill-opacity="0.01" />
      <path
        d="M8.68689 9.31572C8.49162 9.51098 8.17504 9.51098 7.97978 9.31572L5.85355 7.18949C5.53857 6.87451 5.76165 6.33594 6.20711 6.33594L10.4596 6.33594C10.905 6.33594 11.1281 6.87451 10.8131 7.18949L8.68689 9.31572Z"
        fill="#F0F0F0"
      />
    </g>
  </svg>
);

export const MiniDropdownIconClosed: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g filter="url(#filter0_b_6668_7009)">
      <rect width="16" height="16" fill="black" fill-opacity="0.01" />
      <path
        d="M9.31376 7.64384C9.50903 7.8391 9.50903 8.15569 9.31376 8.35095L7.18754 10.4772C6.87256 10.7922 6.33398 10.5691 6.33398 10.1236L6.33398 5.87117C6.33398 5.42572 6.87256 5.20263 7.18754 5.51762L9.31376 7.64384Z"
        fill="#F0F0F0"
      />
    </g>
  </svg>
);

export const TrailWithSplit: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="33" viewBox="0 0 17 33" fill="none">
    <path d="M8 32L8.00001 0L8.00001 12C8.00001 14.2091 9.79087 16 12 16L16 16" stroke="#4F4F4F" stroke-linecap="round" />
  </svg>
);

export const TrailWithoutSplit: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="34" viewBox="0 0 16 34" fill="none">
    <path d="M8 1L8 33" stroke="#4F4F4F" stroke-linecap="round" />
  </svg>
);

export const ThreeDModelIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 14 16" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.81475 1.07226C6.55469 0.67383 7.44531 0.67383 8.18525 1.07226L12.6852 3.49534C13.495 3.93137 14 4.77681 14 5.69651V7.87731C13.6992 7.63619 13.3628 7.43763 13 7.29076V5.69651C13 5.66801 12.9992 5.63963 12.9976 5.61139L7.4753 8.2947V14.1531C7.55597 14.1262 7.63489 14.0922 7.71115 14.0511L8.48839 13.6326C8.72328 13.9011 8.9935 14.1379 9.29179 14.3358L8.18525 14.9316C7.44531 15.33 6.55469 15.33 5.81475 14.9316L1.31475 12.5085C0.504976 12.0725 0 11.227 0 10.3073V5.69651C0 4.77681 0.504975 3.93137 1.31475 3.49534L5.81475 1.07226ZM6.28885 1.95273C6.73281 1.71367 7.26718 1.71367 7.71115 1.95273L12.2111 4.37581C12.3638 4.45802 12.4984 4.56448 12.6113 4.68896L6.97531 7.42848L1.443 4.63216C1.54391 4.53192 1.65995 4.44522 1.78885 4.37581L6.28885 1.95273ZM1 10.3073V5.52786L6.4753 8.29469V14.1357C6.41177 14.1119 6.34947 14.0838 6.28885 14.0511L1.78885 11.628C1.30299 11.3664 1 10.8592 1 10.3073Z"
      fill="#F0F0F0"
    />
    <path
      d="M11.7317 8.60276C11.7021 8.57038 11.6661 8.54452 11.626 8.52683C11.5858 8.50914 11.5425 8.5 11.4986 8.5C11.4547 8.5 11.4113 8.50914 11.3712 8.52683C11.3311 8.54452 11.295 8.57038 11.2654 8.60276L9.58048 10.4459C9.52497 10.508 9.49619 10.5895 9.50041 10.6726C9.50462 10.7558 9.54148 10.8339 9.60298 10.89C9.66448 10.9462 9.74565 10.9757 9.82883 10.9723C9.91202 10.9689 9.9905 10.9328 10.0472 10.8719L11.1829 9.62905V13.7766C11.1829 13.8604 11.2162 13.9407 11.2754 14C11.3347 14.0593 11.415 14.0925 11.4988 14.0925C11.5826 14.0925 11.6629 14.0593 11.7222 14C11.7814 13.9407 11.8147 13.8604 11.8147 13.7766V9.62989L12.9508 10.8727C13.0074 10.9346 13.0862 10.9714 13.17 10.9751C13.2537 10.9788 13.3355 10.9491 13.3973 10.8925C13.4592 10.8359 13.496 10.7571 13.4997 10.6733C13.5034 10.5896 13.4737 10.5078 13.4171 10.4459L11.7317 8.60276Z"
      fill="#F0F0F0"
    />
  </svg>
);

export const ReportBtnIconGrey: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      d="M2.23077 17L15.7692 17C16.449 17 17 16.449 17 15.7692L17 2.23077C17 1.55103 16.449 1 15.7692 1L2.23077 1C1.55103 1 1 1.55103 1 2.23077L1 15.7692C1 16.449 1.55103 17 2.23077 17Z"
      stroke="#F0F0F0"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.07812 4.07812H6.53966M4.07812 7.15505H9.61659M14.5397 7.15505L10.8474 13.3089L6.53966 10.8474L4.07812 14.5397"
      stroke="#F0F0F0"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const ReportBtnIconGreyRectangle: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
    <path
      fill="none"
      stroke="#CCF54E"
      stroke-width="2"
      d="M49 1C49 0.585787 48.4142 0 48 0H2C1.58579 0 1 0.585787 1 1V49C1 49.4142 1.58579 50 2 50H48C48.4142 50 49 49.4142 49 49V26.777C49 26.5461 48.8814 26.3516 48.6887 26.234L45.0307 24.042C44.8276 23.824 44.3071 23.597 43.8383 23.5932V20.3312C43.5925 19.9065 43.2533 19.7693 42.8462 20.0168L40.1614 21.4623C39.8012 21.6745 39.5744 22.0907 39.5744 22.5426V23.2057C39.5744 23.6378 39.8012 24.0537 40.1614 24.2657L42.8462 25.7113C43.2533 25.9588 43.5925 25.8217 43.8383 25.397V22.135C44.3071 21.6312 44.8276 21.4043 45.0307 21.1863L48.6887 18.9944C48.8814 18.8769 49 18.6824 49 18.4515V1Z"
    />
  </svg>
);

export const AddControlModeIson: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 12 12" fill="none">
    <path d="M2.50391 6H9.50391" stroke="#F0F0F0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M6 2.5V9.5" stroke="#F0F0F0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
);

export const ReportIconRectangle: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="65" viewBox="0 0 24 65" fill="none">
    <path
      d="M18 5.24537e-07L22 5.36442e-07L22 65L18 65L18 63.5588C18 62.0857 17.1903 60.7318 15.8925 60.0349L2.1075 52.6318C0.80969 51.9348 2.81819e-06 50.5809 2.62502e-06 49.1078L-1.73069e-06 15.8922C-1.92387e-06 14.4191 0.809685 13.0652 2.10749 12.3682L15.8925 4.96514C17.1903 4.26817 18 2.91428 18 1.44116L18 5.24537e-07Z"
      fill="#030608"
    />
    <path
      d="M21.75 64.75L18.25 64.75L18.25 63.5586L18.2402 63.2666C18.1472 61.913 17.4113 60.6842 16.2627 59.9619L16.0108 59.8145L2.22559 52.4111C1.00909 51.7577 0.250007 50.4883 0.250006 49.1074L0.250002 15.8926C0.250002 14.5978 0.916998 13.4007 2.00293 12.7178L2.22559 12.5889L16.0107 5.18555C17.3896 4.44506 18.2499 3.0065 18.25 1.44141L18.25 0.25L21.75 0.25L21.75 64.75Z"
      stroke="url(#paint0_linear_16195_283178)"
      stroke-opacity="0.73"
      stroke-width="0.5"
    />
    <defs>
      <linearGradient id="paint0_linear_16195_283178" x1="10" y1="44.1328" x2="25" y2="44.1328" gradientUnits="userSpaceOnUse">
        <stop stop-color="#CCF54E" stop-opacity="0.2" />
        <stop offset="0.5649" stop-color="#CCF54E" stop-opacity="0.2" />
        <stop offset="0.565" stop-color="#3F3F3F" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export const InnerDivIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 5L9 10L3 15V5Z" stroke="#CCF54E" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M8.5765 4.68741C9.39138 4.46906 10.2456 4.4411 11.073 4.60568C11.9004 4.77027 12.6789 5.12299 13.3482 5.63656C14.0175 6.15013 14.5597 6.81078 14.9328 7.56741C15.3059 8.32404 15.5 9.15637 15.5 10C15.5 10.8436 15.3059 11.676 14.9328 12.4326C14.5597 13.1892 14.0175 13.8499 13.3482 14.3634C12.6789 14.877 11.9004 15.2297 11.073 15.3943C10.2456 15.5589 9.39138 15.5309 8.5765 15.3126"
      stroke="#CCF54E"
      stroke-linecap="round"
    />
  </svg>
);

export const DividerLine = () => (
  <svg width="349" height="2" viewBox="0 0 349 2" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M349 1.00003L-3.33786e-06 1.00002" stroke="url(#paint0_linear_16180_206754)" stroke-width="0.5" />
    <defs>
      <linearGradient id="paint0_linear_16180_206754" x1="349" y1="1.50003" x2="-2.18557e-08" y2="1.50002" gradientUnits="userSpaceOnUse">
        <stop offset="0.02" stop-color="#CCF54E" stop-opacity="0.1" />
        <stop offset="0.54" stop-color="#CCF54E" stop-opacity="0.4" />
        <stop offset="1" stop-color="#CCF54E" stop-opacity="0.1" />
      </linearGradient>
    </defs>
  </svg>
);

export const BracketsJSONIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M5.33333 2H4.66667C4.31304 2 3.97391 2.14048 3.72386 2.39052C3.47381 2.64057 3.33333 2.97971 3.33333 3.33333V6.66667C3.33333 7.02029 3.19286 7.35943 2.94281 7.60948C2.69276 7.85952 2.35362 8 2 8C2.35362 8 2.69276 8.14048 2.94281 8.39052C3.19286 8.64057 3.33333 8.97971 3.33333 9.33333V12.6667C3.33333 13.4 3.93333 14 4.66667 14H5.33333"
      stroke="#BFBFBF"
      stroke-width="0.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.6667 14H11.3334C11.687 14 12.0262 13.8595 12.2762 13.6095C12.5263 13.3594 12.6667 13.0203 12.6667 12.6667V9.33333C12.6667 8.6 13.2667 8 14.0001 8C13.6465 8 13.3073 7.85952 13.0573 7.60948C12.8072 7.35943 12.6667 7.02029 12.6667 6.66667V3.33333C12.6667 2.97971 12.5263 2.64057 12.2762 2.39052C12.0262 2.14048 11.687 2 11.3334 2H10.6667"
      stroke="#BFBFBF"
      stroke-width="0.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const AdjustSettingsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path
      d="M10.6299 11.6083C10.6297 11.8014 10.4727 11.9578 10.2795 11.9578C10.0864 11.9578 9.92942 11.8014 9.9292 11.6083L9.9292 7.78442C9.9292 7.59112 10.0862 7.43408 10.2795 7.43408C10.4728 7.43408 10.6299 7.59112 10.6299 7.78442L10.6299 11.6083Z"
      fill="#BFBFBF"
    />
    <path
      d="M10.6323 3.57434C10.6323 3.76764 10.4753 3.92468 10.282 3.92468C10.0887 3.92468 9.93164 3.76764 9.93164 3.57434L9.93164 2.09863C9.93164 1.90533 10.0887 1.74829 10.282 1.74829C10.4753 1.74829 10.6323 1.90533 10.6323 2.09863L10.6323 3.57434Z"
      fill="#BFBFBF"
    />
    <path
      d="M10.2821 7.32129C11.1755 7.32129 11.8996 6.59717 11.8997 5.70374C11.8997 4.81026 11.1756 4.08618 10.2821 4.08618C9.38867 4.08624 8.66455 4.81029 8.66455 5.70374C8.66461 6.59713 9.38871 7.32123 10.2821 7.32129ZM10.2821 8.02112C9.00211 8.02106 7.96478 6.98373 7.96472 5.70374C7.96472 4.42369 9.00207 3.38556 10.2821 3.3855C11.5622 3.3855 12.6003 4.42366 12.6003 5.70374C12.6003 6.98377 11.5621 8.02112 10.2821 8.02112Z"
      fill="#BFBFBF"
    />
    <path
      d="M3.36768 2.09778C3.3679 1.90467 3.52486 1.74829 3.71802 1.74829C3.91118 1.74829 4.06814 1.90467 4.06836 2.09778L4.06836 5.92163C4.06836 6.11493 3.91132 6.27197 3.71802 6.27197C3.52472 6.27197 3.36768 6.11493 3.36768 5.92163L3.36768 2.09778Z"
      fill="#BFBFBF"
    />
    <path
      d="M3.36768 10.1317C3.36768 9.93841 3.52472 9.78137 3.71802 9.78137C3.91132 9.78137 4.06836 9.93841 4.06836 10.1317L4.06836 11.6074C4.06836 11.8007 3.91132 11.9578 3.71802 11.9578C3.52472 11.9578 3.36768 11.8007 3.36768 11.6074L3.36768 10.1317Z"
      fill="#BFBFBF"
    />
    <path
      d="M3.7179 6.38477C2.82445 6.38477 2.1004 7.10889 2.10034 8.00232C2.10034 8.8958 2.82442 9.61987 3.7179 9.61987C4.61133 9.61982 5.33545 8.89576 5.33545 8.00232C5.33539 7.10892 4.61129 6.38482 3.7179 6.38477ZM3.7179 5.68494C4.99789 5.68499 6.03522 6.72232 6.03528 8.00232C6.03528 9.28236 4.99793 10.3205 3.7179 10.3206C2.43782 10.3206 1.39966 9.2824 1.39966 8.00232C1.39972 6.72229 2.43785 5.68494 3.7179 5.68494Z"
      fill="#BFBFBF"
    />
  </svg>
);

export const InternalExternalIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
    <path
      d="M13.0098 9.48193C13.0098 9.84961 12.5809 10.0505 12.2985 9.81508L8.20969 6.40775C8.00029 6.23325 8.00189 5.91113 8.21301 5.73872L12.3018 2.39954C12.585 2.16824 13.0098 2.36976 13.0098 2.73542V9.48193ZM4.80733 5.82087C5.01371 5.99629 5.01056 6.31585 4.80078 6.48718L0.707962 9.82964C0.424745 10.0609 0 9.85942 0 9.49376V2.6724C0 2.30274 0.432861 2.10257 0.714517 2.34198L4.80733 5.82087ZM0.867317 7.66753C0.867317 8.03402 1.29375 8.23527 1.57666 8.00228L3.42353 6.48133C3.62954 6.31167 3.63488 5.99797 3.43477 5.8214L1.58789 4.19181C1.30788 3.94474 0.867317 4.14355 0.867317 4.51698V7.66753ZM6.93854 2.16829C6.93854 1.92879 6.74439 1.73464 6.50488 1.73464C6.26538 1.73464 6.07122 1.92879 6.07122 2.16829C6.07122 2.4078 6.26538 2.60195 6.50488 2.60195C6.74439 2.60195 6.93854 2.4078 6.93854 2.16829ZM6.93854 0.433659C6.93854 0.194156 6.74439 0 6.50488 0C6.26538 0 6.07122 0.194156 6.07122 0.433659C6.07122 0.673162 6.26538 0.867318 6.50488 0.867318C6.74439 0.867318 6.93854 0.673162 6.93854 0.433659ZM6.93854 3.90293C6.93854 3.66343 6.74439 3.46927 6.50488 3.46927C6.26538 3.46927 6.07122 3.66343 6.07122 3.90293C6.07122 4.14243 6.26538 4.33659 6.50488 4.33659C6.74439 4.33659 6.93854 4.14243 6.93854 3.90293ZM6.93854 5.63757C6.93854 5.39806 6.74439 5.20391 6.50488 5.20391C6.26538 5.20391 6.07122 5.39806 6.07122 5.63757C6.07122 5.87707 6.26538 6.07122 6.50488 6.07122C6.74439 6.07122 6.93854 5.87707 6.93854 5.63757ZM6.93854 7.3722C6.93854 7.1327 6.74439 6.93854 6.50488 6.93854C6.26538 6.93854 6.07122 7.1327 6.07122 7.3722C6.07122 7.6117 6.26538 7.80586 6.50488 7.80586C6.74439 7.80586 6.93854 7.6117 6.93854 7.3722ZM6.93854 9.10684C6.93854 8.86733 6.74439 8.67318 6.50488 8.67318C6.26538 8.67318 6.07122 8.86733 6.07122 9.10684C6.07122 9.34634 6.26538 9.54049 6.50488 9.54049C6.74439 9.54049 6.93854 9.34634 6.93854 9.10684ZM6.93854 10.8415C6.93854 10.602 6.74439 10.4078 6.50488 10.4078C6.26538 10.4078 6.07122 10.602 6.07122 10.8415C6.07122 11.081 6.26538 11.2751 6.50488 11.2751C6.74439 11.2751 6.93854 11.081 6.93854 10.8415Z"
      fill="#F0F0F0"
    />
  </svg>
);

export const EllipseIconWhite: React.FC<{ isActive?: boolean }> = ({ isActive = false }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
    <circle cx="3" cy="3" r="3" fill={isActive ? "#CCF54E" : "#F0F0F0"} />
  </svg>
);

export const XIconRed: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none">
    <path
      d="M2.1001 2.80005H2.74321C2.95801 2.80005 3.16092 2.89867 3.29363 3.06757L6.04363 6.56753C6.24306 6.82135 6.24307 7.17865 6.04363 7.43248L3.29363 10.9325C3.16092 11.1014 2.95801 11.2 2.7432 11.2H2.1001M11.2001 2.80005H10.557C10.3422 2.80005 10.1393 2.89867 10.0066 3.06757L7.25657 6.56753C7.05713 6.82135 7.05713 7.17865 7.25656 7.43248L10.0066 10.9325C10.1393 11.1014 10.3422 11.2 10.557 11.2H11.2001"
      stroke="#FF3333"
      stroke-width="0.7"
      stroke-linejoin="round"
    />
  </svg>
);

export const LeftbarCloseSvg = ({ active, onClick }: { active: boolean; onClick: () => void }) => (
  <button className={`${active ? "active" : ""} leftbar__close__button__container__sat__design`} onClick={onClick}>
    {!active && (
      <svg width="12" height="39" viewBox="0 0 12 39" fill="none" xmlns="http://www.w3.org/2000/svg">
        <foreignObject x="-40" y="-39.043" width="91.5" height="117.822">
          <div style={{ clipPath: "url(#bgblur_0_13245_284823_clip_path)", height: "100%", width: "100%" }}></div>
        </foreignObject>
        <g data-figma-bg-blur-radius="40">
          <path
            d="M11.5 9.39011V31.6241C11.5 33.3458 10.3983 34.8743 8.76491 35.4188L5.02324 36.666C4.11357 36.9692 3.5 37.8205 3.5 38.7794H0V0.957366H3.5C3.5 2.67909 4.60172 4.20765 6.23509 4.75211L8.76491 5.5954C10.3983 6.13985 11.5 7.66838 11.5 9.39011Z"
            fill="#090909"
            fill-opacity="0.5"
          />
          <path
            d="M11.25 9.39011V31.6241C11.25 33.2382 10.2171 34.6712 8.68585 35.1816L4.94418 36.4288C4.01227 36.7395 3.35976 37.5673 3.26258 38.5294H0.25V1.20737H3.25731C3.35842 2.93328 4.50007 4.43729 6.15603 4.98928L8.68585 5.83257C10.2171 6.343 11.25 7.77599 11.25 9.39011Z"
            stroke="url(#paint0_linear_13245_284822)"
            stroke-opacity="0.1"
            stroke-width="0.5"
          />
        </g>
        <g opacity="0.9">
          <path d="M2.92969 17.5L5.7154 20.75L2.92969 24" stroke="#F0F0F0" stroke-width="0.577778" stroke-miterlimit="16" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M5.71484 17.5L8.50056 20.75L5.71484 24" stroke="#F0F0F0" stroke-width="0.577778" stroke-miterlimit="16" stroke-linecap="round" stroke-linejoin="round" />
        </g>
        <defs>
          <clipPath id="bgblur_0_13245_284822_clip_path" transform="translate(40 39.043)">
            <path d="M11.5 9.39011V31.6241C11.5 33.3458 10.3983 34.8743 8.76491 35.4188L5.02324 36.666C4.11357 36.9692 3.5 37.8205 3.5 38.7794H0V0.957366H3.5C3.5 2.67909 4.60172 4.20765 6.23509 4.75211L8.76491 5.5954C10.3983 6.13985 11.5 7.66838 11.5 9.39011Z" />
          </clipPath>
          <linearGradient id="paint0_linear_13245_284822" x1="11.5" y1="19.8653" x2="-4.5" y2="19.8653" gradientUnits="userSpaceOnUse">
            <stop stop-color="#F0F0F0" />
            <stop offset="0.53" stop-color="#F0F0F0" />
            <stop offset="0.5301" stop-color="#8A8A8A" stop-opacity="0" />
          </linearGradient>
        </defs>
      </svg>
    )}
    {active && (
      <svg width="12" height="38" viewBox="0 0 12 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <foreignObject x="-40" y="-39.9941" width="91.5" height="117.822">
          <div style={{ clipPath: "url(#bgblur_0_13245_284823_clip_path)", height: "100%", width: "100%" }}></div>
        </foreignObject>
        <g data-figma-bg-blur-radius="40">
          <path
            d="M11.5 8.43893V30.6729C11.5 32.3946 10.3983 33.9231 8.76491 34.4676L5.02324 35.7148C4.11357 36.018 3.5 36.8693 3.5 37.8282H0V0.00619364H3.5C3.5 1.72792 4.60172 3.25648 6.23509 3.80093L8.76491 4.64423C10.3983 5.18868 11.5 6.71721 11.5 8.43893Z"
            fill="#090909"
            fill-opacity="0.5"
          />
          <path
            d="M11.25 8.43893V30.6729C11.25 32.287 10.2171 33.72 8.68585 34.2304L4.94418 35.4776C4.01227 35.7883 3.35976 36.6161 3.26258 37.5782H0.25V0.256194H3.25731C3.35842 1.98211 4.50007 3.48612 6.15603 4.03811L8.68585 4.8814C10.2171 5.39183 11.25 6.82482 11.25 8.43893Z"
            stroke="url(#paint0_linear_13245_284817)"
            stroke-opacity="0.1"
            stroke-width="0.5"
          />
        </g>
        <g opacity="0.9">
          <path d="M8.5 16.5488L5.71429 19.7988L8.5 23.0488" stroke="#F0F0F0" stroke-width="0.577778" stroke-miterlimit="16" stroke-linecap="round" stroke-linejoin="round" />
          <path
            d="M5.71484 16.5488L2.92913 19.7988L5.71484 23.0488"
            stroke="#F0F0F0"
            stroke-width="0.577778"
            stroke-miterlimit="16"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="bgblur_0_13245_284817_clip_path" transform="translate(40 39.9941)">
            <path d="M11.5 8.43893V30.6729C11.5 32.3946 10.3983 33.9231 8.76491 34.4676L5.02324 35.7148C4.11357 36.018 3.5 36.8693 3.5 37.8282H0V0.00619364H3.5C3.5 1.72792 4.60172 3.25648 6.23509 3.80093L8.76491 4.64423C10.3983 5.18868 11.5 6.71721 11.5 8.43893Z" />
          </clipPath>
          <linearGradient id="paint0_linear_13245_284817" x1="11.5" y1="18.9141" x2="-4.5" y2="18.9141" gradientUnits="userSpaceOnUse">
            <stop stop-color="#F0F0F0" />
            <stop offset="0.53" stop-color="#F0F0F0" />
            <stop offset="0.5301" stop-color="#8A8A8A" stop-opacity="0" />
          </linearGradient>
        </defs>
      </svg>
    )}
  </button>
);

export const TickIconWhite: React.FC<{ isActive?: boolean }> = ({ isActive = false }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none" className={isActive ? "active" : ""}>
    <path
      d="M10.2101 0.187023C10.3553 -0.0146418 10.6357 -0.0603344 10.8374 0.0848502C11.0391 0.230066 11.0848 0.510492 10.9396 0.71217L4.61585 9.49464C4.53912 9.60119 4.41928 9.66917 4.28845 9.68031C4.15789 9.69129 4.0293 9.64466 3.93579 9.55287L0.134523 5.81642C-0.0426394 5.64219 -0.045166 5.35752 0.12903 5.18031C0.303222 5.00318 0.587919 5.00073 0.765139 5.17482L4.19177 8.54322L10.2101 0.187023Z"
      fill={isActive ? "#C1E55B" : "#F0F0F0"}
    />
  </svg>
);

export const PlusIconWhite: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g opacity="0.6">
      <path d="M3.33331 8H12.6666" stroke="#F0F0F0" stroke-width="0.533333" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M8 3.3335V12.6668" stroke="#F0F0F0" stroke-width="0.533333" stroke-linecap="round" stroke-linejoin="round" />
    </g>
  </svg>
);

export const TrashIconWhite: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
    <path d="M0.400024 2.79932H11.2002" stroke="#F0F0F0" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M10.0001 2.79932V11.1994C10.0001 11.7994 9.40007 12.3994 8.80006 12.3994H2.79999C2.19998 12.3994 1.59998 11.7994 1.59998 11.1994V2.79932"
      stroke="#F0F0F0"
      stroke-width="0.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.40002 2.79993V1.59992C3.40002 0.99991 4.00003 0.399902 4.60004 0.399902H7.00007C7.60008 0.399902 8.20008 0.99991 8.20008 1.59992V2.79993"
      stroke="#F0F0F0"
      stroke-width="0.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const OneNodeIcon: React.FC<{ isActive?: boolean }> = ({ isActive = false }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 55 55" fill="none">
    <g opacity={isActive ? "0.6" : "0.4"}>
      <rect x="0.5" y="0.5" width="54" height="54" rx="2" stroke={isActive ? "#CCF54E" : "#F0F0F0"} />
      <circle cx="27.5" cy="27.5" r="2" fill={isActive ? "#CCF54E" : "#F0F0F0"} />
    </g>
  </svg>
);

export const FiveNodeIcon: React.FC<{ isActive?: boolean }> = ({ isActive = false }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 55 55" fill="none">
    <g opacity={isActive ? "0.6" : "0.4"}>
      <rect x="0.5" y="0.5" width="54" height="54" rx="2" stroke={isActive ? "#CCF54E" : "#F0F0F0"} />
      <circle cx="27.5" cy="27.5" r="2" fill={isActive ? "#CCF54E" : "#F0F0F0"} />
      <circle cx="48.5" cy="6.5" r="2" fill={isActive ? "#CCF54E" : "#F0F0F0"} />
      <circle cx="48.5" cy="48.5" r="2" fill={isActive ? "#CCF54E" : "#F0F0F0"} />
      <circle cx="6.5" cy="6.5" r="2" fill={isActive ? "#CCF54E" : "#F0F0F0"} />
      <circle cx="6.5" cy="48.5" r="2" fill={isActive ? "#CCF54E" : "#F0F0F0"} />
    </g>
  </svg>
);

export const NineNodeIcon: React.FC<{ isActive?: boolean }> = ({ isActive = false }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="55" height="55" viewBox="0 0 55 55" fill="none">
    <g opacity={isActive ? "0.6" : "0.4"}>
      <rect x="0.5" y="0.5" width="54" height="54" rx="2" stroke={isActive ? "#CCF54E" : "#F0F0F0"} />
      <circle cx="27.5" cy="27.5" r="2" fill={isActive ? "#CCF54E" : "#F0F0F0"} />
      <circle cx="27.5" cy="48.5" r="2" fill={isActive ? "#CCF54E" : "#F0F0F0"} />
      <circle cx="27.5" cy="6.5" r="2" fill={isActive ? "#CCF54E" : "#F0F0F0"} />
      <circle cx="48.5" cy="27.5" r="2" fill={isActive ? "#CCF54E" : "#F0F0F0"} />
      <circle cx="6.5" cy="27.5" r="2" fill={isActive ? "#CCF54E" : "#F0F0F0"} />
      <circle cx="48.5" cy="6.5" r="2" fill={isActive ? "#CCF54E" : "#F0F0F0"} />
      <circle cx="48.5" cy="48.5" r="2" fill={isActive ? "#CCF54E" : "#F0F0F0"} />
      <circle cx="6.5" cy="6.5" r="2" fill={isActive ? "#CCF54E" : "#F0F0F0"} />
      <circle cx="6.5" cy="48.5" r="2" fill={isActive ? "#CCF54E" : "#F0F0F0"} />
    </g>
  </svg>
);

export const InfoIcon: React.FC<{ isActive?: boolean }> = ({ isActive = false }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M8 14.002C11.3137 14.002 14 11.3157 14 8.00195C14 4.68824 11.3137 2.00195 8 2.00195C4.68629 2.00195 2 4.68824 2 8.00195C2 11.3157 4.68629 14.002 8 14.002Z"
      stroke={isActive ? "#CCF54E" : "#F0F0F0"}
      strokeOpacity="1"
      strokeLinecap="round"
      strokeWidth="1"
      strokeLinejoin="round"
    />
    <path d="M8 5.33594H8.00667V5.3426H8V5.33594Z" stroke={isActive ? "#CCF54E" : "#F0F0F0"} strokeOpacity="1" strokeWidth="1" strokeLinejoin="round" />
    <path d="M8 8.00195V10.6686" stroke={isActive ? "#CCF54E" : "#F0F0F0"} strokeOpacity="1" strokeLinecap="round" strokeWidth="1" strokeLinejoin="round" />
  </svg>
);

export const ThermalSettingsIcon: React.FC<{ isActive?: boolean }> = ({ isActive = false }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g opacity="0.8">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.85156 10.6367V13.1826C3.85154 13.4035 3.67207 13.583 3.45117 13.583C3.23045 13.5828 3.0508 13.4034 3.05078 13.1826V10.6367H3.85156ZM3.45117 2.41797C3.67196 2.41797 3.85135 2.59762 3.85156 2.81836V7.21973H3.05078V2.81836C3.05099 2.59775 3.23057 2.41818 3.45117 2.41797Z"
        fill="#F0F0F0"
      />
      <rect x="1.6001" y="8.19727" width="3.67427" height="1.46172" rx="0.730858" fill="#F0F0F0"  />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.9771 10.6367V13.1826C12.977 13.4035 12.7976 13.583 12.5767 13.583C12.3559 13.5828 12.1763 13.4034 12.1763 13.1826V10.6367H12.9771ZM12.5767 2.41797C12.7974 2.41797 12.9768 2.59762 12.9771 2.81836V7.21973H12.1763V2.81836C12.1765 2.59775 12.3561 2.41818 12.5767 2.41797Z"
        fill="#F0F0F0"
      />
      <rect
        x="10.7256"
        y="8.19727"
        width="3.67427"
        height="1.46172"
        rx="0.730858"
        fill="#F0F0F0"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.41406 7.71387V13.1826C8.41404 13.4035 8.23457 13.583 8.01367 13.583C7.79295 13.5828 7.6133 13.4034 7.61328 13.1826V7.71387H8.41406ZM8.01367 2.41797C8.23446 2.41797 8.41385 2.59762 8.41406 2.81836V4.2959H7.61328V2.81836C7.61349 2.59775 7.79307 2.41818 8.01367 2.41797Z"
        fill="#F0F0F0"
      />
      <rect
        x="6.16309"
        y="5.27344"
        width="3.67427"
        height="1.46172"
        rx="0.730858"
        fill="#F0F0F0"
      />
    </g>
  </svg>
);

export const FillAllIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path d="M14.6875 1.6875H3.3125C2.41504 1.6875 1.6875 2.41504 1.6875 3.3125V14.6875C1.6875 15.585 2.41504 16.3125 3.3125 16.3125H14.6875C15.585 16.3125 16.3125 15.585 16.3125 14.6875V3.3125C16.3125 2.41504 15.585 1.6875 14.6875 1.6875Z" stroke="#F0F0F0" strokeWidth="0.609375" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8.63488 7.17194L6.807 5.34407M11.5565 8.99981H5.3597M7.72094 6.258L8.50619 5.47275C8.5888 5.39015 8.70084 5.34375 8.81766 5.34375C8.93448 5.34375 9.04652 5.39015 9.12913 5.47275L11.7964 8.13998C11.879 8.22259 11.9254 8.33463 11.9254 8.45145C11.9254 8.56827 11.879 8.68031 11.7964 8.76292L9.02092 11.5384C8.77309 11.7862 8.43698 11.9254 8.08651 11.9254C7.73605 11.9254 7.39994 11.7862 7.15211 11.5384L5.73075 10.117C5.48296 9.86917 5.34375 9.53306 5.34375 9.1826C5.34375 8.83214 5.48296 8.49602 5.73075 8.24819L6.68636 7.29258M12.3436 11.3322C12.1304 11.157 11.9829 10.9147 11.925 10.6449C11.8683 10.9151 11.7205 11.1577 11.5065 11.3322C11.2963 11.5003 11.1939 11.7051 11.1939 11.9153C11.1927 12.012 11.2107 12.1081 11.2469 12.1979C11.2831 12.2876 11.3368 12.3693 11.4048 12.4382C11.4728 12.507 11.5538 12.5617 11.6431 12.599C11.7324 12.6364 11.8283 12.6556 11.925 12.6556C12.0218 12.6556 12.1177 12.6364 12.207 12.599C12.2963 12.5617 12.3773 12.507 12.4453 12.4382C12.5133 12.3693 12.567 12.2876 12.6032 12.1979C12.6394 12.1081 12.6574 12.012 12.6562 11.9153C12.6562 11.7032 12.552 11.5022 12.3436 11.3322Z" stroke="#F0F0F0" strokeWidth="0.609375" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const ClearAllIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path d="M14.6875 1.6875H3.3125C2.41504 1.6875 1.6875 2.41504 1.6875 3.3125V14.6875C1.6875 15.585 2.41504 16.3125 3.3125 16.3125H14.6875C15.585 16.3125 16.3125 15.585 16.3125 14.6875V3.3125C16.3125 2.41504 15.585 1.6875 14.6875 1.6875Z" stroke="#F0F0F0" strokeWidth="0.609375" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5.34821 5.34375L12.6562 12.6517M7.66852 5.59521C8.33011 5.33681 9.05268 5.27683 9.74783 5.42261C10.443 5.56839 11.0806 5.91361 11.5826 6.41604C12.0846 6.91847 12.4294 7.55633 12.5746 8.25159C12.7199 8.94685 12.6593 9.66937 12.4004 10.3308M11.5893 11.584C11.2495 11.9237 10.8462 12.1932 10.4023 12.3771C9.95845 12.5609 9.4827 12.6556 9.00225 12.6556C8.5218 12.6556 8.04605 12.5609 7.60217 12.3771C7.15829 12.1932 6.75497 11.9237 6.41523 11.584C6.0755 11.2443 5.80601 10.8409 5.62215 10.3971C5.43829 9.95318 5.34366 9.47744 5.34366 8.99698C5.34366 8.51653 5.43829 8.04078 5.62215 7.5969C5.80601 7.15302 6.0755 6.7497 6.41523 6.40997" stroke="#F0F0F0" strokeWidth="0.609375" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const NoCoatingIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
    <rect x="0.5" y="0.5" width="35" height="35"  fill-opacity="0.2" stroke="#f0f0f020" strokeWidth="0.609375"/>
  </svg>
);

export const MLICoatingIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
  <rect opacity="0.6" width="36" height="36" fill="url(#pattern0_42195_17667)"/>
  <defs>
    <pattern id="pattern0_42195_17667" patternUnits="userSpaceOnUse" patternTransform="matrix(168.3 0 0 168.3 -132.3 0)" preserveAspectRatio="none" viewBox="0 0 99 99" width="1" height="1">
      <g id="pattern0_42195_17667_inner">
        <path d="M99 3.50711L3.50711 99H0.88043L99 0.88043V3.50711Z" fill="#F2A93B" />
        <path d="M99 7.46711L7.46711 99H4.84043L99 4.84043V7.46711Z" fill="#F2A93B" />
        <path d="M99 11.4271L11.4271 99H8.80043L99 8.80043V11.4271Z" fill="#F2A93B" />
        <path d="M99 15.3871L15.3871 99H12.7604L99 12.7604V15.3871Z" fill="#F2A93B" />
        <path d="M99 19.3471L19.3471 99H16.7204L99 16.7204V19.3471Z" fill="#F2A93B" />
        <path d="M99 23.3071L23.3071 99H20.6804L99 20.6804V23.3071Z" fill="#F2A93B" />
        <path d="M99 27.2671L27.2671 99H24.6404L99 24.6404V27.2671Z" fill="#F2A93B" />
        <path d="M99 31.2271L31.2271 99H28.6004L99 28.6004V31.2271Z" fill="#F2A93B" />
        <path d="M99 35.1871L35.1871 99H32.5604L99 32.5604V35.1871Z" fill="#F2A93B" />
        <path d="M99 39.1471L39.1471 99H36.5204L99 36.5204V39.1471Z" fill="#F2A93B" />
        <path d="M99 43.1071L43.1071 99H40.4804L99 40.4804V43.1071Z" fill="#F2A93B" />
        <path d="M99 47.0671L47.0671 99H44.4404L99 44.4404V47.0671Z" fill="#F2A93B" />
        <path d="M99 51.0271L51.0271 99H48.4004L99 48.4004V51.0271Z" fill="#F2A93B" />
        <path d="M99 54.9871L54.9871 99H52.3606L99 52.3604V54.9871Z" fill="#F2A93B" />
        <path d="M99 58.9471L58.9471 99H56.3206L99 56.3204V58.9471Z" fill="#F2A93B" />
        <path d="M99 62.9071L62.9071 99H60.2806L99 60.2804V62.9071Z" fill="#F2A93B" />
        <path d="M99 66.8671L66.8671 99H64.2406L99 64.2404V66.8671Z" fill="#F2A93B" />
        <path d="M99 70.8271L70.8271 99H68.2006L99 68.2004V70.8271Z" fill="#F2A93B" />
        <path d="M99 74.7871L74.7871 99H72.1606L99 72.1604V74.7871Z" fill="#F2A93B" />
        <path d="M99 78.7471L78.7471 99H76.1206L99 76.1204V78.7471Z" fill="#F2A93B" />
        <path d="M99 82.7071L82.7071 99H80.0806L99 80.0804V82.7071Z" fill="#F2A93B" />
        <path d="M99 86.6671L86.6671 99H84.0406L99 84.0404V86.6671Z" fill="#F2A93B" />
        <path d="M99 90.6271L90.6271 99H88.0006L99 88.0004V90.6271Z" fill="#F2A93B" />
        <path d="M99 94.5871L94.5871 99H91.9606L99 91.9604V94.5871Z" fill="#F2A93B" />
        <path d="M99 98.5471L98.5471 99H95.9206L99 95.9204V98.5471Z" fill="#F2A93B" />
        <path d="M0 98.5471V95.9204L95.9206 0H98.5471L0 98.5471Z" fill="#F2A93B" />
        <path d="M0 94.5871V91.9604L91.9606 0H94.5871L0 94.5871Z" fill="#F2A93B" />
        <path d="M0 90.6271V88.0004L88.0006 0H90.6271L0 90.6271Z" fill="#F2A93B" />
        <path d="M0 86.6671V84.0404L84.0406 0H86.6671L0 86.6671Z" fill="#F2A93B" />
        <path d="M0 82.7071V80.0804L80.0806 0H82.7071L0 82.7071Z" fill="#F2A93B" />
        <path d="M0 78.7471V76.1204L76.1206 0H78.7471L0 78.7471Z" fill="#F2A93B" />
        <path d="M0 74.7871V72.1604L72.1606 0H74.7871L0 74.7871Z" fill="#F2A93B" />
        <path d="M0 70.8271V68.2004L68.2006 0H70.8271L0 70.8271Z" fill="#F2A93B" />
        <path d="M0 66.8671V64.2404L64.2406 0H66.8671L0 66.8671Z" fill="#F2A93B" />
        <path d="M0 62.9071V60.2804L60.2806 0H62.9071L0 62.9071Z" fill="#F2A93B" />
        <path d="M0 58.9471V56.3204L56.3206 0H58.9471L0 58.9471Z" fill="#F2A93B" />
        <path d="M0 54.9871V52.3604L52.3606 0H54.9871L0 54.9871Z" fill="#F2A93B" />
        <path d="M0 51.0271V48.4004L48.4004 0H51.0271L0 51.0271Z" fill="#F2A93B" />
        <path d="M0 47.0671V44.4404L44.4404 0H47.0671L0 47.0671Z" fill="#F2A93B" />
        <path d="M0 43.1071V40.4804L40.4804 0H43.1071L0 43.1071Z" fill="#F2A93B" />
        <path d="M0 39.1471V36.5204L36.5204 0H39.1471L0 39.1471Z" fill="#F2A93B" />
        <path d="M0 35.1871V32.5604L32.5604 0H35.1871L0 35.1871Z" fill="#F2A93B" />
        <path d="M0 31.2271V28.6004L28.6004 0H31.2271L0 31.2271Z" fill="#F2A93B" />
        <path d="M0 27.2671V24.6404L24.6404 0H27.2671L0 27.2671Z" fill="#F2A93B" />
        <path d="M0 23.3071V20.6804L20.6804 0H23.3071L0 23.3071Z" fill="#F2A93B" />
        <path d="M0 19.3471V16.7204L16.7204 0H19.3471L0 19.3471Z" fill="#F2A93B" />
        <path d="M0 15.3871V12.7604L12.7604 0H15.3871L0 15.3871Z" fill="#F2A93B" />
        <path d="M0 11.4271V8.80064L8.80064 0H11.4271L0 11.4271Z" fill="#F2A93B" />
        <path d="M0 7.46711V4.84064L4.84064 0H7.46711L0 7.46711Z" fill="#F2A93B" />
        <path d="M0 3.50711V0.880645L0.880645 0H3.50711L0 3.50711Z" fill="#F2A93B" />
      </g>
    </pattern></defs>
  </svg>
);

export const OSRCoatingIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
  <rect opacity="0.6" width="36" height="36" fill="url(#pattern0_42195_17687)"/>
  <defs>
    <pattern id="pattern0_42195_17687" patternUnits="userSpaceOnUse" patternTransform="matrix(168.3 0 0 168.3 -132.3 0)" preserveAspectRatio="none" viewBox="0 0 99 99" width="1" height="1">
      <g id="pattern0_42195_17687_inner">
        <path d="M99 3.50711L3.50711 99H0.88043L99 0.88043V3.50711Z" fill="#83CF5E" />
        <path d="M99 7.46711L7.46711 99H4.84043L99 4.84043V7.46711Z" fill="#83CF5E" />
        <path d="M99 11.4271L11.4271 99H8.80043L99 8.80043V11.4271Z" fill="#83CF5E" />
        <path d="M99 15.3871L15.3871 99H12.7604L99 12.7604V15.3871Z" fill="#83CF5E" />
        <path d="M99 19.3471L19.3471 99H16.7204L99 16.7204V19.3471Z" fill="#83CF5E" />
        <path d="M99 23.3071L23.3071 99H20.6804L99 20.6804V23.3071Z" fill="#83CF5E" />
        <path d="M99 27.2671L27.2671 99H24.6404L99 24.6404V27.2671Z" fill="#83CF5E" />
        <path d="M99 31.2271L31.2271 99H28.6004L99 28.6004V31.2271Z" fill="#83CF5E" />
        <path d="M99 35.1871L35.1871 99H32.5604L99 32.5604V35.1871Z" fill="#83CF5E" />
        <path d="M99 39.1471L39.1471 99H36.5204L99 36.5204V39.1471Z" fill="#83CF5E" />
        <path d="M99 43.1071L43.1071 99H40.4804L99 40.4804V43.1071Z" fill="#83CF5E" />
        <path d="M99 47.0671L47.0671 99H44.4404L99 44.4404V47.0671Z" fill="#83CF5E" />
        <path d="M99 51.0271L51.0271 99H48.4004L99 48.4004V51.0271Z" fill="#83CF5E" />
        <path d="M99 54.9871L54.9871 99H52.3606L99 52.3604V54.9871Z" fill="#83CF5E" />
        <path d="M99 58.9471L58.9471 99H56.3206L99 56.3204V58.9471Z" fill="#83CF5E" />
        <path d="M99 62.9071L62.9071 99H60.2806L99 60.2804V62.9071Z" fill="#83CF5E" />
        <path d="M99 66.8671L66.8671 99H64.2406L99 64.2404V66.8671Z" fill="#83CF5E" />
        <path d="M99 70.8271L70.8271 99H68.2006L99 68.2004V70.8271Z" fill="#83CF5E" />
        <path d="M99 74.7871L74.7871 99H72.1606L99 72.1604V74.7871Z" fill="#83CF5E" />
        <path d="M99 78.7471L78.7471 99H76.1206L99 76.1204V78.7471Z" fill="#83CF5E" />
        <path d="M99 82.7071L82.7071 99H80.0806L99 80.0804V82.7071Z" fill="#83CF5E" />
        <path d="M99 86.6671L86.6671 99H84.0406L99 84.0404V86.6671Z" fill="#83CF5E" />
        <path d="M99 90.6271L90.6271 99H88.0006L99 88.0004V90.6271Z" fill="#83CF5E" />
        <path d="M99 94.5871L94.5871 99H91.9606L99 91.9604V94.5871Z" fill="#83CF5E" />
        <path d="M99 98.5471L98.5471 99H95.9206L99 95.9204V98.5471Z" fill="#83CF5E" />
        <path d="M0 98.5471V95.9204L95.9206 0H98.5471L0 98.5471Z" fill="#83CF5E" />
        <path d="M0 94.5871V91.9604L91.9606 0H94.5871L0 94.5871Z" fill="#83CF5E" />
        <path d="M0 90.6271V88.0004L88.0006 0H90.6271L0 90.6271Z" fill="#83CF5E" />
        <path d="M0 86.6671V84.0404L84.0406 0H86.6671L0 86.6671Z" fill="#83CF5E" />
        <path d="M0 82.7071V80.0804L80.0806 0H82.7071L0 82.7071Z" fill="#83CF5E" />
        <path d="M0 78.7471V76.1204L76.1206 0H78.7471L0 78.7471Z" fill="#83CF5E" />
        <path d="M0 74.7871V72.1604L72.1606 0H74.7871L0 74.7871Z" fill="#83CF5E" />
        <path d="M0 70.8271V68.2004L68.2006 0H70.8271L0 70.8271Z" fill="#83CF5E" />
        <path d="M0 66.8671V64.2404L64.2406 0H66.8671L0 66.8671Z" fill="#83CF5E" />
        <path d="M0 62.9071V60.2804L60.2806 0H62.9071L0 62.9071Z" fill="#83CF5E" />
        <path d="M0 58.9471V56.3204L56.3206 0H58.9471L0 58.9471Z" fill="#83CF5E" />
        <path d="M0 54.9871V52.3604L52.3606 0H54.9871L0 54.9871Z" fill="#83CF5E" />
        <path d="M0 51.0271V48.4004L48.4004 0H51.0271L0 51.0271Z" fill="#83CF5E" />
        <path d="M0 47.0671V44.4404L44.4404 0H47.0671L0 47.0671Z" fill="#83CF5E" />
        <path d="M0 43.1071V40.4804L40.4804 0H43.1071L0 43.1071Z" fill="#83CF5E" />
        <path d="M0 39.1471V36.5204L36.5204 0H39.1471L0 39.1471Z" fill="#83CF5E" />
        <path d="M0 35.1871V32.5604L32.5604 0H35.1871L0 35.1871Z" fill="#83CF5E" />
        <path d="M0 31.2271V28.6004L28.6004 0H31.2271L0 31.2271Z" fill="#83CF5E" />
        <path d="M0 27.2671V24.6404L24.6404 0H27.2671L0 27.2671Z" fill="#83CF5E" />
        <path d="M0 23.3071V20.6804L20.6804 0H23.3071L0 23.3071Z" fill="#83CF5E" />
        <path d="M0 19.3471V16.7204L16.7204 0H19.3471L0 19.3471Z" fill="#83CF5E" />
        <path d="M0 15.3871V12.7604L12.7604 0H15.3871L0 15.3871Z" fill="#83CF5E" />
        <path d="M0 11.4271V8.80064L8.80064 0H11.4271L0 11.4271Z" fill="#83CF5E" />
        <path d="M0 7.46711V4.84064L4.84064 0H7.46711L0 7.46711Z" fill="#83CF5E" />
        <path d="M0 3.50711V0.880645L0.880645 0H3.50711L0 3.50711Z" fill="#83CF5E" />
      </g>
    </pattern></defs>
  </svg>
);

export const ToggleOffGrayIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16" fill="none">
  <rect x="1" y="1" width="22" height="14" rx="2" fill="#F0F0F0" fill-opacity="0.1" />
  <path opacity="0.4" d="M3 4C3 3.44772 3.44772 3 4 3L12 3C12.5523 3 13 3.44772 13 4L13 12C13 12.5523 12.5523 13 12 13L4 13C3.44772 13 3 12.5523 3 12L3 4Z" fill="#F0F0F0" />
</svg>
);

export const ToggleOnGreenIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16" fill="none">
  <rect x="1" y="1" width="22" height="14" rx="2" fill="#CCF54E" fill-opacity="0.1"/>
  <path d="M11 4C11 3.44772 11.4477 3 12 3L20 3C20.5523 3 21 3.44772 21 4L21 12C21 12.5523 20.5523 13 20 13L12 13C11.4477 13 11 12.5523 11 12L11 4Z" fill="#CCF54E"/>
</svg>);

export const UploadSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M13 9L13 12C13 12.5523 12.5523 13 12 13L2 13C1.44772 13 1 12.5523 1 12L1 9M7 1L7 8M7 8L8.5 6.5M7 8L5.5 6.5" stroke="#F0F0F0" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
)

export const DownloadSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M13 9L13 12C13 12.5523 12.5523 13 12 13L2 13C1.44772 13 1 12.5523 1 12L1 9M7 1L7 8M7 1L8.5 2.5M7 1L5.5 2.5" stroke="#F0F0F0" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);

export const RedundantIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M2 5C2 3.89543 2.89543 3 4 3H10C11.1046 3 12 3.89543 12 5V11C12 12.1046 11.1046 13 10 13H4C2.89543 13 2 12.1046 2 11V5Z" stroke="#F0F0F0" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6 8C6 6.89543 6.89543 6 8 6H14C15.1046 6 16 6.89543 16 8V14C16 15.1046 15.1046 16 14 16H8C6.89543 16 6 15.1046 6 14V8Z" stroke="#CCF54E" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);